import { IonText, IonItem, IonLabel, IonItemDivider, IonLoading } from "@ionic/react";
import React, {useState} from "react";
import { useSelector } from "react-redux";
import { MessageItem } from "../../../components/Message/MessageItem";
import { selectMessages } from "../../../store/users/selectors/selectMessages";
import { selectFetchMessagesStatus } from "../../../store/users/selectors/selectFetchMessagesStatus";

export const ActivitySection: React.FC = () => {
  const messages = useSelector(selectMessages);
  const fetchMessagesStatus = useSelector(selectFetchMessagesStatus);
  return (
    <>
      <h2 className="ion-padding-horizontal">
        <IonText color="primary">Actividad</IonText>
      </h2>
      <IonLoading
        cssClass="my-custom-class"
        isOpen={fetchMessagesStatus === 'pending' && Object.entries(messages).length === 0 }
        message={'Cargando...'}
        duration={5000}
        spinner={'lines'}
      />
      <section className="ion-padding-horizontal">
        {Object.entries(messages).length === 0 && (
          <IonItem lines="none">
            <IonLabel>
              <IonText color="medium">No se ha encontrado actividad</IonText>
            </IonLabel>
          </IonItem>
        )}
        {Object.entries(messages).map(([key, value]: any) => (
          <article key={key}>
            <IonItemDivider className="ion-margin-bottom">{key}</IonItemDivider>

            {value.map((messageItem: any) => (
              <MessageItem
                key={messageItem.id}
                message={messageItem}
                routerLink={`/app/rrhh/acuerdos/${messageItem.document?.id}`}
              ></MessageItem>
            ))}
          </article>
        ))}
      </section>
    </>
  );
};
